import { TimelineLite } from 'gsap/TimelineLite';


const cursor = ((el) => {
  const tl = new TimelineLite({ paused: true });

  tl
    .add('start')
    .fromTo(el, 0.1, {
      scale: 0,
      transformOrigin: '50% 50%',
    }, {
      transformOrigin: '50% 50%',
      scale: 1,
    })
    .to(el, 2, {
      transformOrigin: '50% 50%',
      scale: 0,
      fillOpacity: 1,
    });

  return tl;
});

export default cursor;



// WEBPACK FOOTER //
// ./src/scripts/timelines/cursor.js